<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/6chap1#chap1">INTRODUCTION by Terry Bisson</a></p>
<p class="toc1"><a href="#/7chap2#chap2">THE WAR OF THE WORLDVIEWS</a></p>
<p class="toc1"><span href="#/8chap3#chap3" title="Link target outside of Sample">THE WISDOM OF THE SKIN</span></p>
<p class="toc1"><span href="#/9chap4#chap4" title="Link target outside of Sample">MARTYRS OF THE UPSHOT KNOTHOLE</span></p>
<p class="toc1"><span href="#/10chap5#chap5" title="Link target outside of Sample">COME BACK, DR. SARCOPHAGUS</span></p>
<p class="toc1"><span href="#/11chap6#chap6" title="Link target outside of Sample">THE FATE OF NATIONS</span></p>
<p class="toc1"><span href="#/12chap7#chap7" title="Link target outside of Sample">THE EYE THAT NEVER BLINKS</span></p>
<p class="toc1"><span href="#/13chap8#chap8" title="Link target outside of Sample">DIRECTOR’S CUT</span></p>
<p class="toc1"><span href="#/14chap9#chap9" title="Link target outside of Sample">AUSPICIOUS EGGS</span></p>
<p class="toc1"><span href="#/15chap10#chap10" title="Link target outside of Sample">APOLOGUE</span></p>
<p class="toc1"><span href="#/16chap11#chap11" title="Link target outside of Sample">FUCKING JUSTICE</span></p>
<p class="toc1"><span href="#/17chap12#chap12" title="Link target outside of Sample">ISABELLA OF CASTILE ANSWERS HER MAIL</span></p>
<p class="toc1"><span href="#/18chap13#chap13" title="Link target outside of Sample">THE ZOMBIES OF MONTROSE</span></p>
<p class="toc1"><span href="#/19chap14#chap14" title="Link target outside of Sample">THE CAT’S PAJAMAS</span></p>
<p class="toc1"><span href="#/20biography#biography" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4TOC.vue?9f5a9624